import { Injectable } from '@angular/core';
import {  Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuidanceSearchService {

  private currentIndex = 0;
  private rootList: number[] = [];

  private rootCounter = new Subject<any>();

  rootCounter$ = this.rootCounter.asObservable();

  constructor() { }

  setNewRootList(rootList: number[])
  {
    this.rootList = rootList;
    this.currentIndex = 0;
    this.rootCounter.next({root: this.rootList[this.currentIndex], currentLevel: null, isLast: this.currentIndex == this.rootList.length - 1});
  }

  onRootResolved(currentLevel: any)
  {
    this.currentIndex++;
    if(this.currentIndex <= this.rootList.length - 1)
    {
      this.rootCounter.next({root: this.rootList[this.currentIndex], currentLevel: currentLevel, isLast: this.currentIndex == this.rootList.length - 1});
    }
  }
}
